import styled from 'styled-components';

export const TextareaWrapper = styled.div`
  margin-bottom: 24px;
  width: 100%;
`;

export const TextareaLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
`;

export const RequiredAsterisk = styled.span`
  color: #1a1a1a;
  margin-left: 2px;
  font-size: 16px;
`;

export const ErrorMessage = styled.p`
  color: #f73450;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: block;
`;

export const TextareaContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  background-color: ${(props) => (props.isDisabled ? '#fafafa' : 'white')};
  border: 1.5px solid ${(props) => (props.hasError ? '#f73450' : '#e0e0e0')};
  border-radius: 24px;
  padding: 16px 20px;
  transition: all 0.2s ease;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'text')};

  ${(props) =>
    props.isFocused &&
    !props.isDisabled &&
    !props.hasError &&
    `
    border-color: #b0b0b0;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
  `}

  ${(props) =>
    props.hasError &&
    `
    border-color: #f73450;
    box-shadow: 0 0 0 3px rgba(247, 52, 80, 0.1);
  `}
`;

export const TextareaIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 12px;
  margin-top: 2px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  font-size: 20px;
`;

export const TextareaField = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #1a1a1a;
  background-color: transparent;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  resize: vertical;
  min-height: 80px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  line-height: 1.5;

  &::placeholder {
    color: #999;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
    resize: none;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
  }
`;

export const TextareaFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-family: 'Inter', sans-serif;
`;

export const WordCount = styled.div`
  font-size: 14px;
  color: ${(props) => {
    if (props.isAtLimit) return '#e74c3c';
    if (props.isNearLimit) return '#e67e22';
    return '#999';
  }};
  font-weight: ${(props) => (props.isAtLimit ? '500' : '400')};
  transition: color 0.2s ease;
`;

export const CharacterCount = styled.div`
  font-size: 14px;
  color: #999;
`;
